import api from 'api';

export const loadMasterCampaignTable = api(
  'POST /api/influencers-master-campaigns/grid'
);

export const loadMasterCampaignDetails = api(
  'GET /api/influencers-master-campaigns/:id/details'
);

export const loadMasterCampaign = api(
  'GET /api/influencers-master-campaigns/:id'
);

export const createMasterCampaign = api(
  'POST /api/influencers-master-campaigns'
);

export const updateMasterCampaign = api(
  'PUT /api/influencers-master-campaigns/:id'
);

export const deleteMasterCampaign = api(
  'POST /api/influencers-master-campaigns/:id/delete'
);

export const importAgenciesMasterCampaign = api(
  'POST /api/influencers-master-campaigns/:id/import-agencies'
);

export const uploadMasterCampaign = async ({
  fileInFormData,
  masterCampaignId,
}) => {
  fileInFormData.append('masterCampaignId', masterCampaignId);

  return await api(`POST /api/influencers-master-campaigns/import`)(
    fileInFormData
  );
};

export const checkUploadMasterCampaign = api(
  'GET /api/influencers-master-campaigns/import/:jobId/status'
);

export const downloadMasterCampaigns = api(
  'GET /api/influencers-master-campaigns/export',
  {
    responseType: 'blob',
  }
);
